/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Spoznaj nove ljudi, klepetaj in se druži",
      "Nepravilna telefonska številka",
      "Get the app",
      "Nadaljuj z Applom",
      "Nadaljuj z Facebookom",
      "Nadaljuj z Googlom",
      "Prijava",
      "Registracija",
      "Za nadaljevanje vnesi znake, ki jih vidiš v polju za vnos.",
      "Nadaljuj",
      "Vnesi znake",
      "Varnostno preverjanje",
      "Ponovno naloži",
      "Ustvari novo geslo, ki si ga lahko enostavno zapomniš:",
      "Posodobi",
      "Potrdi geslo",
      "Geslo mora imeti vsaj {{num}} [[characters:num@3]]",
      "Geslo",
      "Ustvari novo geslo",
      "Badoo - Blog",
      "Zaposlitev",
      "Klepet",
      "Mesta",
      "Upravljaj s piškotki",
      "Avtorske pravice © 2006 - danes. Bumble. Vse pravice pridržane.",
      "Apple in Apple Logo sta blagovni znamki podjetja Apple Inc.{{__EOL__}}Google Play in logotip Google Play je blagovna znamka Google LLC.",
      "Prenesi",
      "Facebook",
      "Sledi nam",
      "Središče za pomoč",
      "Instagram",
      "Jezik",
      "LinkedIn",
      "Pregled",
      "Badoo je del Bumble Inc.",
      "Pravilnik o zasebnosti",
      "Središče za pomoč",
      "Zemljevid strani",
      "Izjava o sodobnem suženjstvu",
      "Pravila in pogoji",
      "Twitter",
      "Vnesi svoj e-poštni naslov ali telefonsko številko in poslali ti bomo navodila za kreacijo novega gesla.",
      "Prejmi novo geslo",
      "Vnesi svoj e-poštni naslov ali telefonsko številko",
      "Pozabljeno geslo",
      "Modeli so uporabljeni samo za namene upodobitve",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Ni potrebe, da čakaš na vzajemno simpatijo.{{__EOL__}}{{__EOL__}}. Začni konkretne pogore in preidi na najpomembnejše - spoznavanje.",
      "Želiš klepetati takoj?",
      "Z registracijo se strinjaš z našimi <a class=\"link\" href=\"{{terms_url}}\">Pravili in pogoji</a>. Preberi, kako uporabljamo tvoje podatke v našem <a class=\"link\" href=\"{{privacy_url}}\">Pravilniku o zasebnosti.</a>",
      "Pomagamo ti, da se pokažev v svojo pravi luči, <br />za prijetno spoznavanje novih ljudi.",
      "Za spoznavanje s samozavestjo",
      "ali",
      "Že imaš račun?",
      "Registriraj se s svojim e-poštnim naslovom ali telefonsko številko",
      "Poišči točno to, kar iščeš.{{__EOL__}}Ni potrebe po opravičevanju.",
      "Želiš samo klepetati? Vredu.{{__EOL__}}Se želiš ustaliti? Odlično.{{__EOL__}}{{__EOL__}}In kadar koli si lahko premisliš.",
      "Želim na zmenek",
      "Želi prijateljstvo",
      "Želi klepetati",
      "Spoznaj ljudi, ki želijo isto kot ti.",
      "{{name}}, {{age}}",
      "Tvoja varnost je naša prioriteta.",
      "Naš Safety Centre na enem mestu združuje vso pomoč, ki jo potrebuješ za spoznavanje s samozavestjo.",
      "Obišči naš Safety Centre",
      "Varnost nam je <br/>vedno na prvem mestu.",
      "Že od prvega trenutka se mi je zdelo, da iz tega bo nekaj ...",
      "\"Na začetku me ni zanimalo nič resnega ...\"",
      "Nasvet za vse, ki uporabljajo aplikacijo Badoo, bi bil, da naj bodo to, kar so ...",
      "Badoo Zgodbe o uspehu",
      "Preberi več zgodb o uspehu",
      "{{num}}__CUT__Ocena",
      "Apple App Store",
      "Zaupaj nam. Združili smo na milijone (in milijone in milijone) ljudi od leta 2006.",
      "{{num}}M+__CUT__prenosov",
      "{{num}} mio.",
      "Trgovina Google Play",
      "Izkušeni smo v tem, kar delamo.",
      "Prijavi se s svojim e-poštnim naslovom ali telefonsko številko",
      "Vnesi svoje geslo",
      "Pozabljeno geslo?",
      "Registracija",
      "Nimaš računa?",
      "Prijava",
      "Registracija"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "znaki",
                  "znakov",
                  "znakom",
                  "znake",
                  "znakih",
                  "znaki"
            ],
            "plural": [
                  "znakov",
                  "znakov",
                  "znakom",
                  "znakov",
                  "znakih",
                  "znaki"
            ],
            "singular": [
                  "znak",
                  "znaka",
                  "znaku",
                  "znak",
                  "znaku",
                  "znakom"
            ],
            "two": [
                  "znaka",
                  "znakov",
                  "znakoma",
                  "znaka",
                  "znakih",
                  "znakoma"
            ]
      },
      "day": {
            "few": [
                  "dnevi",
                  "dni",
                  "dnevom",
                  "dni",
                  "dneh",
                  "dnevi"
            ],
            "plural": [
                  "dni",
                  "dni",
                  "dnevom",
                  "dni",
                  "dneh",
                  "dnevi"
            ],
            "singular": [
                  "dan",
                  "dneva",
                  "dnevu",
                  "dan",
                  "dnevu",
                  "dnevom"
            ],
            "two": [
                  "dni",
                  "dni",
                  "dnevoma",
                  "dni",
                  "dnevih",
                  "dnevoma"
            ]
      },
      "hour": {
            "few": [
                  "ure",
                  "ur",
                  "uram",
                  "ure",
                  "urah",
                  "urami"
            ],
            "plural": [
                  "ur",
                  "ur",
                  "uram",
                  "ur",
                  "urah",
                  "urami"
            ],
            "singular": [
                  "ura",
                  "ure",
                  "uri",
                  "uro",
                  "uri",
                  "uro"
            ],
            "two": [
                  "uri",
                  "ur",
                  "urama",
                  "uri",
                  "urah",
                  "urama"
            ]
      },
      "minute": {
            "few": [
                  "minute",
                  "minut",
                  "minutam",
                  "minute",
                  "minutah",
                  "minutami"
            ],
            "plural": [
                  "minut",
                  "minut",
                  "minutam",
                  "minut",
                  "minutah",
                  "minutami"
            ],
            "singular": [
                  "minuta",
                  "minute",
                  "minuti",
                  "minuto",
                  "minuti",
                  "minuto"
            ],
            "two": [
                  "minuti",
                  "minut",
                  "minutama",
                  "minuti",
                  "minutah",
                  "minutama"
            ]
      },
      "month": {
            "few": [
                  "meseci",
                  "mesecev",
                  "mesecem",
                  "mesece",
                  "mesecih",
                  "meseci"
            ],
            "plural": [
                  "mesecev",
                  "mesecev",
                  "mesecem",
                  "mesecev",
                  "mesecih",
                  "meseci"
            ],
            "singular": [
                  "mesec",
                  "meseca",
                  "mesecu",
                  "mesec",
                  "mesecu",
                  "mesecom"
            ],
            "two": [
                  "meseca",
                  "mesecev",
                  "mesecema",
                  "meseca",
                  "mesecih",
                  "mesecema"
            ]
      },
      "second": {
            "few": [
                  "sekunde",
                  "sekund",
                  "sekundam",
                  "sekunde",
                  "sekundah",
                  "sekundami"
            ],
            "plural": [
                  "sekund",
                  "sekund",
                  "sekundam",
                  "sekund",
                  "sekundah",
                  "sekundami"
            ],
            "singular": [
                  "sekunda",
                  "sekunde",
                  "sekundi",
                  "sekundo",
                  "sekundi",
                  "sekundo"
            ],
            "two": [
                  "sekundi",
                  "sekund",
                  "sekundama",
                  "sekundi",
                  "sekundah",
                  "sekundama"
            ]
      },
      "year": {
            "few": [
                  "leta",
                  "let",
                  "letom",
                  "leta",
                  "letih",
                  "leti"
            ],
            "plural": [
                  "let",
                  "let",
                  "letom",
                  "let",
                  "letih",
                  "leti"
            ],
            "singular": [
                  "leto",
                  "leta",
                  "letu",
                  "leto",
                  "letu",
                  "letom"
            ],
            "two": [
                  "leti",
                  "let",
                  "letoma",
                  "leti",
                  "letih",
                  "letoma"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
